<div [formGroup]="form" class="mt-2">
  <mat-card class="card-style-full px-2">
    <mat-card-header class="flex justify-between items-center text-center">
      <mat-card-title class="">Cadastro de exame, associação de tutor local e parâmetros</mat-card-title>
      <button class="btn-icon" (click)="close()">
        <mat-icon>close</mat-icon>
      </button>
    </mat-card-header>

    <div class="flex justify-between items-center mt-3 -mx-2">
      <mat-form-field class="input-tg w-4/12 px-2" appearance="outline">
        <mat-label>Tipo de Exame</mat-label>
        <mat-select formControlName="examType">
          @for (type of listTipoExames; track type) {
            <mat-option [value]="type.id">{{ type.descricao }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field class="input-tg w-4/12 px-2" appearance="outline">
        <mat-label>Exame(subtipo)</mat-label>
        <mat-select [disabled]="!subtipoExameEnable" formControlName="examSubType">
          @for (type of listSubtipoExames; track type) {
            <mat-option [value]="type.id">{{ type.descricao }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field class="input-tg w-4/12 px-2" appearance="outline">
        <mat-label>Tutor local associado</mat-label>
        <mat-select formControlName="idMedico">
          @for (type of doctorsList; track type) {
            <mat-option [value]="type.id">{{ type.nome_principal }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="flex justify-between items-center mb-2 mt-1 mx-2">
    <mat-form-field class="input-tg w-full px-2" appearance="outline">
      <mat-label>Observação - Descrição</mat-label>
      <textarea matInput formControlName="descricao"></textarea>
    </mat-form-field>
    </div>
<!--    <div class="flex justify-between items-center mb-4 mt-3 -mx-2">-->
<!--      <mat-slide-toggle-->
<!--        class="input-tg w-12/12 px-2"-->
<!--        formControlName="parameterPattern"-->
<!--      >Usar parâmetros personalizados:-->
<!--        <strong>{{ form.get('parameterPattern')?.value ? 'Sim' : 'Não' }}</strong>-->
<!--      </mat-slide-toggle>-->
<!--    </div>-->

    <!-- Seção de Parâmetros Personalizados -->
    @if (form.get('parameterPattern')?.value) {
      <div class="border border-gray-300 rounded-lg p-4 mt-4">
        <h3 class="text-lg font-semibold mb-3">Parâmetros Personalizados</h3>

        <div [formGroup]="formParametro">
          <div class="flex justify-between items-center -mx-2 mb-3">
            <mat-form-field class="input-tg w-3/12 px-2" appearance="outline">
              <mat-label>Contexto</mat-label>
              <mat-select formControlName="contexto">
                @for (type of listContextos; track type) {
                  <mat-option [value]="type.id">{{ type.nome }}</mat-option>
                }
              </mat-select>
            </mat-form-field>

            <mat-form-field class="input-tg w-3/12 px-2" appearance="outline">
              <mat-label>Valor mínimo</mat-label>
              <input matInput type="number" formControlName="parametro_minimo" />
            </mat-form-field>

            <mat-form-field class="input-tg w-3/12 px-2" appearance="outline">
              <mat-label>Valor máximo</mat-label>
              <input matInput type="number" formControlName="parametro_maximo" />
            </mat-form-field>

            <mat-form-field class="input-tg w-3/12 px-2" appearance="outline">
              <mat-label>Unidade de medida</mat-label>
              <mat-select formControlName="tipo_unidade">
                @for (type of listUnidadesMedida; track type) {
                  <mat-option [value]="type.id">{{ type.tipo_unidade }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>

          <div class="flex gap-2 justify-end">
            @if (editingParametroIndex >= 0) {
              <button
                mat-stroked-button
                type="button"
                (click)="cancelEditParametro()"
              >
                Cancelar
              </button>
            }
            <button
              mat-flat-button
              class="btn-tg"
              type="button"
              [disabled]="!formParametro.valid"
              (click)="addParametro()"
            >
              @if (editingParametroIndex >= 0) {
                Atualizar Parâmetro
              } @else {
                Adicionar Parâmetro
              }
            </button>
          </div>
        </div>

        <!-- Lista de Parâmetros Adicionados -->
        @if (parametros.length > 0) {
          <div class="mt-4">
            <h4 class="font-semibold mb-2">Parâmetros adicionados:</h4>
            <div class="space-y-2">
              @for (param of parametros; track param; let i = $index) {
                <div class="flex justify-between items-center bg-gray-50 p-3 rounded border border-gray-200">
                  <div class="flex-1">
                    <span class="font-medium">{{ param.contextoDescricao }}</span>
                    <span class="mx-2">|</span>
                    <span>Min: {{ param.parametro_minimo }}</span>
                    <span class="mx-2">-</span>
                    <span>Max: {{ param.parametro_maximo }}</span>
                    <span class="mx-2">|</span>
                    <span>{{ param.tipoUnidadeDescricao }}</span>
                  </div>
                  <div class="flex gap-2">
                    <button
                      mat-icon-button
                      type="button"
                      (click)="editParametro(i)"
                      [disabled]="editingParametroIndex >= 0 && editingParametroIndex !== i"
                    >
                      <mat-icon>edit</mat-icon>
                    </button>
                    <button
                      mat-icon-button
                      color="warn"
                      type="button"
                      (click)="removeParametro(i)"
                      [disabled]="editingParametroIndex >= 0"
                    >
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>
                </div>
              }
            </div>
          </div>
        }
      </div>
    }

    <div class="flex mt-4 justify-center">
      <button
        mat-flat-button
        class="btn-tg w-1/5"
        type="button"
        [disabled]="!checkForm() || loading"
        (click)="addTariff()"
      >
        @if (loading) {
          <mat-spinner diameter="22" class="loading-spinner"></mat-spinner>
        } @else {
          @if (edit) {
            Editar
          } @else {
            Adicionar
          }
        }
      </button>
    </div>
  </mat-card>
</div>
